import { Component, OnInit } from '@angular/core';
import {TopicService} from '../../services/topic.service';
import {Topic} from '../topic/model/topic';
import {Observable} from 'rxjs/Rx';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {UserService} from '../../services/user.service';
import {Login} from '../../services/user.service';

@Component({
	selector: 'app-share',
	templateUrl: './share.component.html',
	styleUrls: ['./share.component.css'],
})

export class ShareComponent implements OnInit {
  public hex = require("../../../assets/hex.jpg");
	topics: Topic[];
	public model = new Topic('', '', '');
	theUser: string;

	constructor(private topicService: TopicService, private activatedRoute: ActivatedRoute, private userSVC: UserService, private router: Router) { }

	ngOnInit() { 
		this.theUser = this.userSVC.loggedInUser.email;
		if (!this.theUser) {
			this.router.navigate(['']);
		}

		this.activatedRoute.queryParams.subscribe(params => {
      this.model.hashTag = params['h'] || "";
       if(this.model.hashTag != "") {
       this.open(()=>{});
       }
		});
	}

  open(callback: () => any) {
      this.topicService.filterTopics(this.model.hashTag, "", "", "", this.theUser)
            .subscribe(
                topics => {
               this.topics = topics; //Bind to view
               if(this.topics !== undefined) {
                 callback();
         this.model = this.topics[0];
         this.share();
               }
           },
           err => {
               console.log(err);
           });
  }

  share() {
        this.userSVC.notify(this.model);
  }

   editDoc() {
      this.router.navigate(['/admin/doc'],  { queryParams: { h : this.model.hashTag}});
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/share/share.component.ts